import { render, staticRenderFns } from "./Vaccinations.vue?vue&type=template&id=070441b5&scoped=true&"
import script from "./Vaccinations.vue?vue&type=script&lang=js&"
export * from "./Vaccinations.vue?vue&type=script&lang=js&"
import style0 from "./Vaccinations.vue?vue&type=style&index=0&id=070441b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070441b5",
  null
  
)

export default component.exports